module.exports = __webpack_public_path__ + "assets/media/w2_1.8d0741ea.mp4";